const fill = (array, x, i, j) => array.fill(x, i, j);
export default fill;
